import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EditGuard implements CanDeactivate<any>  {
  public bypassMe: boolean=false;
  canDeactivate (component: any,
                currentRoute: ActivatedRouteSnapshot,
                currentState: RouterStateSnapshot,
                nextState?: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    
    if (component && !component.isDirty)
      return true;
    if (this.bypassMe)
      return true;
    console.log(nextState);
    return confirm(`Lose changes?`);
  }

}
